<template>
  <div>
    <div class="page-head">
      <div>
        <h2>灵感探索管理</h2>
        <p>维护小程序首页和灵感探索列表展示的图文内容，不写入方案模板。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增灵感</el-button>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词">
          <el-input v-model="filters.keyword" placeholder="标题/标签/描述/正文" clearable />
        </el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="展示中" value="active" />
            <el-option label="已隐藏" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="灵感标题" min-width="180"><template slot-scope="{ row }">{{ row.name || row.title }}</template></el-table-column>
        <el-table-column prop="tag" label="推荐标签" width="140" />
        <el-table-column prop="suitable_people" label="适合人群" min-width="180" />
        <el-table-column prop="description" label="摘要" min-width="220" show-overflow-tooltip />
        <el-table-column prop="status" label="小程序展示" width="160">
          <template slot-scope="{ row }"><publish-switch :value="row.status" @change="changeStatus(row, $event)" /></template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="130">
          <template slot-scope="{ row }"><sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" /></template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" class="danger-text" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增灵感内容' : '编辑灵感内容'" :visible.sync="drawerVisible" width="760px" destroy-on-close>
      <el-form ref="form" class="drawer-form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="灵感标题" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="推荐标签"><el-input v-model="form.tag" placeholder="如：半日轻游 / 亲子文化 / 城市漫游" /></el-form-item>
        <el-form-item label="适合人群"><el-input v-model="form.suitable_people" /></el-form-item>
        <el-form-item label="封面图"><asset-upload v-model="form.cover_url" category="inspirations" /></el-form-item>
        <el-form-item label="摘要"><el-input v-model="form.description" type="textarea" :rows="3" /></el-form-item>
        <el-form-item label="正文内容"><rich-text-editor v-model="form.content" /></el-form-item>
        <el-form-item label="卡片动作"><el-select v-model="form.action_type"><el-option label="查看灵感详情" value="detail"/><el-option label="跳转关联线路" value="route"/><el-option label="填写定制需求" value="customize"/></el-select></el-form-item>
        <el-form-item v-if="form.action_type === 'route'" label="关联线路"><el-select v-model="form.linked_route_id" filterable><el-option v-for="item in routes" :key="item.id" :label="item.name || item.title" :value="item.id"/></el-select></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import PublishSwitch from "../components/PublishSwitch.vue";
import SortInput from "../components/SortInput.vue";
import AssetUpload from "../components/AssetUpload.vue";
import RichTextEditor from "../components/RichTextEditor.vue";
import { changeResourceStatus, createResource, deleteResource, listResource, updateResource } from "../api/resources";

const resourceName = "inspiration-items";

export default {
  name: "InspirationItemsManage",
  components: { AssetUpload, PagedTable, PublishSwitch, RichTextEditor, SortInput },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      form: this.emptyForm(),
      routes: [],
      rules: { name: [{ required: true, message: "请填写灵感标题", trigger: "blur" }] }
    };
  },
  mounted() {
    this.fetchList();
    this.fetchRoutes();
  },
  methods: {
    emptyForm() {
      return {
        name: "",
        title: "",
        tag: "",
        suitable_people: "",
        cover_url: "",
        description: "",
        content: "",
        action_type: "detail",
        linked_route_id: 0
      };
    },
    async fetchRoutes(){const res=await listResource("routes",{status:"active",page:1,pageSize:100});this.routes=res.data&&res.data.items?res.data.items:[];},
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource(resourceName, { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row, name: row.name || row.title || "" };
      this.drawerVisible = true;
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          const payload = { ...this.form, title: this.form.name };
          if (this.drawerMode === "create") await createResource(resourceName, payload);
          else await updateResource(resourceName, this.form.id, payload);
          this.$message.success("灵感内容已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus(resourceName, row.id, status);
      this.$message.success(status === "active" ? "灵感内容已展示" : "灵感内容已隐藏");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource(resourceName, row.id, { ...row, sort_order: sortOrder });
      this.$message.success("排序已更新");
      this.fetchList();
    },
    remove(row) {
      this.$confirm("确定删除该灵感内容吗？", "删除灵感", { type: "warning" })
        .then(async () => {
          await deleteResource(resourceName, row.id);
          this.$message.success("灵感内容已删除");
          this.fetchList();
        })
        .catch(() => {});
    }
  }
};
</script>
